import Button from 'components/Button/Button';
import CountryLogo from 'components/CountryLogo/CountryLogo';
import FooterNav from 'components/FooterNav/FooterNav';
import withColorQuery, { WithColorQueryProps } from 'enhancers/withColorQuery';
import withCountry, { IWithCountryProps } from 'enhancers/withCountry';
import withLanguageState, { WithLanguageProps } from 'enhancers/withLanguageState';
import * as React from 'react';
import styled from 'styled-components';
import { getTextColor } from 'utils/colors';
import Section from 'wrappers/Section/Section';

type Props = WithColorQueryProps & IWithCountryProps & WithLanguageProps;

export const Footer: React.SFC<Props> = props => {
  const backgroundImage =
    !props.loading &&
    props.data &&
    props.data.fetch.Common.Footer &&
    props.data.fetch.Common.Footer.BackgroundImage
      ? props.data.fetch.Common.Footer.BackgroundImage.src
      : '';
  const backgroundColor =
    !props.loading &&
    props.data &&
    props.data.fetch.Common.Footer &&
    props.data.fetch.Common.Footer.BackgroundColor
      ? props.data.fetch.Common.Footer.BackgroundColor
      : '#ffffff';

  const textColor = getTextColor(backgroundColor);

  return (
    <div
      style={{
        background: backgroundImage
          ? `url(${backgroundImage})`
          : backgroundColor,
        color: textColor
      }}
    >
      <StyledSection>
        <Container>
          <Left>
            <LogoContainer>
              <CountryLogo color={textColor} />
            </LogoContainer>
            <FooterNav />
          </Left>
          <Right>
            {
              <React.Fragment>
                <Text>
                  {!props.loading &&
                  props.data &&
                  props.data.fetch.Country.FooterConfig &&
                  props.data.fetch.Country.FooterConfig.FooterText
                    ? props.getText(
                        props.data.fetch.Country.FooterConfig.FooterText
                      )
                    : 'Want to be a local operator and would like to host regional qualifiers in your country?'}
                </Text>
                <Button
                  link={
                    !props.loading &&
                    props.data &&
                    props.data.fetch.Country.FooterConfig &&
                    props.data.fetch.Country.FooterConfig.PartnerLink
                      ? props.getText(
                          props.data.fetch.Country.FooterConfig.PartnerLink
                        )
                      : `/become-partner`
                  }
                >
                  {!props.loading &&
                  props.data &&
                  props.data.fetch.Country.FooterConfig &&
                  props.data.fetch.Country.FooterConfig.PartnerText
                    ? props.getText(
                        props.data.fetch.Country.FooterConfig.PartnerText
                      )
                    : 'Become a partner'}
                </Button>
              </React.Fragment>
            }
          </Right>
        </Container>
      </StyledSection>
    </div>
  );
};

const Right = styled.div`
  display: flex;
  flex-direction: column;
  @media (max-width: 1200px) {
    max-width: 500px;
  }
`;

const StyledSection = styled(Section)``;

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
`;

// const Image = styled(LoadingImage)`
//   width: 130px;
//   height: auto;
//   @media (max-width: 450px) {
//     width: 50px;
//   }
// `;

const Container = styled.div`
  padding: 20px 80px;
  display: flex;
  justify-content: space-between;
  @media (max-width: 800px) {
    flex-direction: column;
    align-items: center;
    padding: 15px;
  }
`;

const Text = styled.span`
  display: block;
  width: 460px;
  font-size: 14px;
  margin: 20px 0;
  @media (max-width: 1200px) {
    width: initial;
  }
  @media (max-width: 600px) {
    text-align: center;
    width: 100%;
  }
`;

const Left = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  @media (max-width: 1200px) {
    justify-content: space-around;
  }
  @media (max-width: 600px) {
    flex-direction: column;
    & > * {
      margin: 15px 0;
    }
  }
`;

// const Logos = styled.div`
//   flex: 1;
//   justify-content: center;
//   align-items: center;
//   display: flex;
//   & > * {
//     margin: 0 40px;
//   }
//   /* @media (max-width: 1400px) {
//     margin-top: 20px;
//     justify-content: space-around;
//     & > * {
//       margin: 0;
//     }
//   } */
// `;

export default withLanguageState(withCountry(withColorQuery(Footer)));



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.tsx